<template>
    <span class="cart-count">{{ quantity }}</span>
</template>

<script>
import { onMounted, ref } from 'vue'
import emitter from '../../utils/emitter';

export default {

    props: ['quantityProp'],

    setup(props) {

        const quantity = ref(0)

        onMounted( () => {
            quantity.value = props.quantityProp
            emitter.on('updateBasket', (data) => quantity.value = data)
        })

        return {
            quantity
        }
    }
}
</script>
